const Socials = () => {
  return (
    <div className="d-flex gap-3 position-relative">
      <a
        style={{ color: "#131619" }}
        className="social-link"
        href="https://www.linkedin.com/in/cheyenne-threadgill/"
      >
        <i className="fs-3 fa-brands fa-linkedin-in"></i>
      </a>
      <a
        style={{ color: "#131619" }}
        className="social-link"
        href="https://github.com/cheyennethreadgill"
      >
        <i className="fs-3 fa-brands fa-github"></i>
      </a>
      <a
        style={{ color: "#131619" }}
        className="social-link"
        href="mailto:threadgillcheyenne@gmail.com"
      >
        <i className="fs-3 fa-regular fa-envelope"></i>
      </a>
    </div>
  );
};

export default Socials;
